console.log("gallery.js loaded");

const html = document.documentElement;
const body = document.body;

import Swiper from 'swiper';
import { Zoom, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import "swiper/css/zoom";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

var gallery_swipers = [];

function initialiseSwipers()
{
    gallery_swipers.forEach(gallery_swiper =>
    {
        if (gallery_swiper instanceof Swiper)
        {
            gallery_swiper.destroy();
        }
    });
    
    document.querySelectorAll('section.gallery .gallery_container').forEach((gallery, index) => {
        const parent_section = gallery.closest("section");
        let loop = true;
        const number_of_images = gallery.querySelectorAll(".swiper-slide").length;
        let autoplay = false;

        if (parent_section.classList.contains("autoplay"))
        {
            autoplay = { delay: 5000, }
        }
        
        let desktopSlidesPerView = 1;
        let i;
        for (i=2;i<=10;i++)
        {
            if (parent_section.classList.contains("slides_per_view_"+i))
            {
                desktopSlidesPerView = i;
                break;
            }
        }
        
        let mobileSlidesPerView = 1;

        for (i=2;i<=10;i++)
        {
            if (parent_section.classList.contains("slides_per_view_mobile_"+i))
            {
                mobileSlidesPerView = i;
                break;
            }
        }
        if (parent_section.classList.contains("hide_navigation_arrows"))
        {
            gallery.querySelector(".swiper-button-prev").remove();
            gallery.querySelector(".swiper-button-next").remove();
        }
        if (parent_section.classList.contains("hide_pagination_dots"))
        {
            gallery.querySelector(".swiper-pagination").remove();
        }
        let swiper_options = {
            modules: [Zoom, Navigation, Pagination],
            direction: 'horizontal',
            loop: loop,
            autoplay: autoplay,
            zoom: true,
            slidesPerView: mobileSlidesPerView,
            slidesPerGroup: mobileSlidesPerView,
            watchOverflow: true,
            centerInsufficientSlides: true,
        
            navigation: {
                    nextEl: parent_section.querySelector(".swiper-button-next"),
                    prevEl:  parent_section.querySelector(".swiper-button-prev"),
                },
            pagination: {
                    el: gallery.querySelector(".swiper-pagination"),
                    clickable: true,
            },

            breakpoints: {
                0: {
                    slidesPerView: mobileSlidesPerView,
                    slidesPerGroup: mobileSlidesPerView,
                },
                768: {
                    slidesPerView: desktopSlidesPerView,
                    slidesPerGroup: desktopSlidesPerView,
                }
            }
        };
        console.log(mobileSlidesPerView, desktopSlidesPerView);
        let gallery_swiper = new Swiper(gallery.querySelector(".swiper"), swiper_options);
    });

}

document.addEventListener("DOMContentLoaded", () => {
    initialiseSwipers();
    Fancybox.bind("[data-fancybox]", {
        Thumbs: {
            type: 'classic',
        },
        Toolbar: {
            display: {
                left: [],
                middle: ['infobar'],
                right: ['close'],
            },
          },
      });
});